import React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SeparatingFactFromFiction() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll();
  const {
    ref: subRef,
    isVisible: subVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section id="separating-fact-from-fiction" className="relative flex min-h-[60vh] flex-col justify-center overflow-hidden bg-linear-to-b from-accent/30 via-background/50 to-background py-[150px]">
      {}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,var(--accent),transparent_70%)] opacity-20" />

      <div className="container relative z-10 mx-auto px-4 text-center">
        <div ref={headerRef} className={`transition-all duration-1000 ease-out ${headerVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h1 className="font-serif text-6xl font-medium leading-[0.9] tracking-tight text-foreground sm:text-7xl md:text-[5rem]">
            Evidence &gt; Folklore
          </h1>
        </div>

        <div ref={subRef} className={`mx-auto mt-8 max-w-2xl transition-all delay-200 duration-1000 ease-out ${subVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <p className="font-sans text-lg text-muted-foreground md:text-xl">
            We analyze common dental beliefs against peer-reviewed clinical data.
          </p>

          <div className="mt-12 flex justify-center">
            <Button asChild variant="ghost" className="group rounded-full text-muted-foreground hover:bg-accent/20 hover:text-foreground">
              <Link to="#common-myths">
                Explore the Analysis
                <ArrowDown className="ml-2 size-4 transition-transform duration-300 group-hover:translate-y-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}